import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import zoomReset from './zoom-reset';

var ZoomOut =
/*#__PURE__*/
function (_zoomReset) {
  _inherits(ZoomOut, _zoomReset);

  function ZoomOut() {
    var _this;

    _classCallCheck(this, ZoomOut);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZoomOut).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a._toggle = function () {
      a.isEnabled() && a.zoomOut();
    };

    return _this;
  }

  _createClass(ZoomOut, [{
    key: "getName",
    value: function getName() {
      return 'zoomOutButton';
    }
  }, {
    key: "configureButton",
    value: function configureButton() {
      var a = this;
      a.config.skipGraphics || a.setLinkedItem('button', a.createButton({
        icon: 'zoomOutIcon',
        handlers: {
          click: a._toggle
        },
        tooltext: a.config.tooltext,
        state: 'activated'
      }));
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g = this,
          h = g.config.hookFn,
          i = {},
          j = 0;
      g.getFromEnv('axesObArr').forEach(function (k) {
        a = k.stack.pop(), b = k.stack.length, j += b;
        a && (k.isY ? (e = a.minValue, f = a.maxValue) : (c = a.minValue, d = a.maxValue, i = g.constructor._getZoomInfo(c, d, k.axis)), h && h(a.minValue, a.maxValue), k.axis.setVisibleConfig(a.minValue, a.maxValue));
      }), g._raiseZoomEvents('zoomout', 'zoomedout', Object.assign(i, {
        level: b,
        startX: c,
        endX: d,
        startY: e,
        endY: f
      })), j || this.disable();
    }
  }]);

  return ZoomOut;
}(zoomReset);

export default ZoomOut;